export class UserLicenseStateApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLicenseStates({ userId, companyId }) {
    return this.#http.get(`/api/companies/${companyId}/users/${userId}/state-licenses`);
  }

  async createLicenseState({ companyId, userId, ...body }) {
    return this.#http.post(`/api/companies/${companyId}/users/${userId}/state-licenses`, body);
  }

  async editLicenseState({ companyId, userId, licenseId, ...body }) {
    return this.#http.put(
      `/api/companies/${companyId}/users/${userId}/state-licenses/${licenseId}`,
      body,
    );
  }

  async deleteLicenseState({ userId, companyId, licenseId }) {
    return this.#http.delete(
      `/api/companies/${companyId}/users/${userId}/state-licenses/${licenseId}`,
    );
  }
}
